import { createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
import { defineComponent } from "vue";
export default defineComponent({
  name: "BattleListItem",
  props: {
    battleData: {
      type: Object,
      required: true,
      default() {
        return {};
      }
    }
  },
  emits: ["select-team"],
  setup(props, {
    emit
  }) {
    const isVictory = (teamId, victoryTeamId) => teamId === victoryTeamId;
    const handleSelectTeam = (name, members) => {
      emit("select-team", {
        name,
        members
      });
    };
    return () => {
      const {
        redTeamId,
        redTeamName,
        blueTeamId,
        blueTeamName,
        victoryTeamId,
        redMembers,
        blueMembers
      } = props.battleData;
      return _createVNode("div", {
        "class": "battle-list-item"
      }, [_createVNode("div", {
        "class": "battle-list-item-teams"
      }, [isVictory(redTeamId, victoryTeamId) && _createVNode("img", {
        "class": "battle-list-item-win battle-list-item-win__left",
        "src": require("@/assets/img/m/homePage/win-icon.png")
      }, null), _createVNode("span", {
        "class": "left",
        "onClick": () => handleSelectTeam(redTeamName, redMembers)
      }, [`${redTeamName} `]), _createTextVNode("vs"), _createVNode("span", {
        "class": "right",
        "onClick": () => handleSelectTeam(blueTeamName, blueMembers)
      }, [` ${blueTeamName}`]), isVictory(blueTeamId, victoryTeamId) && _createVNode("img", {
        "class": "battle-list-item-win battle-list-item-win__right",
        "src": require("@/assets/img/m/homePage/win-icon.png")
      }, null)])]);
    };
  }
});